import copy from "copy-to-clipboard";
import styled from "styled-components";
import { breakpoints, media, size, theme } from "../../../../helpers/theme";
import { ReactComponent as Copy } from "../../../../assets/icons/copy.svg";
import { AdSmallTextBar, KContactBox } from '../../faq/styles';
import Icon from "../../../../components/icon";
import React from "react";


export type BoxDescriptionProps = {
    key: number;
    description: string;
    isCopable: boolean;
};
export interface KContactBoxWithTitleProps {
    boxTitle: string;
    BoxDescription: BoxDescriptionProps[];
};

export interface KopiujButton {
    value: string;
}
const copyToClipboard = (value: string) => {
    copy(value);
}

export const Kopiuj = ({ value }: KopiujButton) => {
    return (
        <span
            style={{
                color: `${theme.colors.gray01_secondaryText}`,
                cursor: "pointer"
            }}
            onClick={() => { copyToClipboard(value) }}>
            <Icon
                width="20px"
                height="20px"
                icon={<Copy style={{ padding: "2px" }} />}
            />
            Kopiuj
        </span>
    )
}

export const KContactBoxWithTitle = ({ boxTitle, BoxDescription }: KContactBoxWithTitleProps) => {
    return (
        <Container >
            <Title>{boxTitle}</Title>
            <KContactBox>
                <AdSmallTextBar />
                <AdSmallText>
                    {BoxDescription.map((item, index) => (

                        <div key={item.key} >
                            <span >{item.description === ""
                                ? <br />
                                : <>{item.description}
                                    {item.isCopable
                                        ?
                                        <Kopiuj value={item.description} />
                                        :
                                        <></>
                                    }
                                </>
                            }

                            </span>
                        </div>

                    ))}

                </AdSmallText>
            </KContactBox>
        </Container >
    )
};


const Title = styled.div`
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: 700;
font-size: 18px;
line-height: 22px;
color: ${theme.colors.black_primaryText};
padding-bottom:29px;

@media (max-width:${breakpoints.laptop}px) {
    padding-top: 24px;
 }
@media (min-width:${breakpoints.laptopHelper}px) {
    padding-top: 10px;
 }
`;

const Container = styled.div`
height:100%;
display:flex;
flex-direction:column;
padding-right:10px;
width:fit-content;
justify-content: left;
align-items:stretch;

${media.between('mobileL', 'tablet')}{

}


@media (max-width:${size.mobileL}) {
    padding-right:0px;
    width: 100%;  
}
`;
const AdSmallText = styled.p`
font-family: ${theme.fonts.interMedium};
font-weight: 500;
font-size: 14px;
line-height: 20px;
width: 100%;
argin-block: 0;
margin: 0px;

& span{
    white-space: nowrap;
    flex-direction: row;
    display: flex;
}
@media (max-width:${size.mobileL}) {
    & span{
        white-space: break-spaces;
    }
}
`;